import { RefreshMiamiBanner } from 'src/components/refresh-miami-banner/refresh-miami-banner';
import { SfistBayAreaBanner } from 'src/components/sfist-bay-area-banner/sfist-bay-area-banner';
import { SanDiegoShortTermRentalsBanner } from 'src/features/homeowners/componentes/san-diego-short-term-rentals-banner/san-diego-short-term-rentals-banner';
import css from './landing-page.module.css';

export const REGION_ARTICLES_MAP: Record<string, () => JSX.Element> = {
  BayArea: SfistBayAreaBanner,
  Miami: RefreshMiamiBanner,
  SanDiego: SanDiegoShortTermRentalsBanner,
};

export const stepsBlocks = {
  section1: [
    {
      src: 'homeowner-lp/ho_lp_section_02.jpg',
      title: (
        <div className={css.stepsSection1Card1}>
          {'Guaranteed Rental\u00a0Payments'}
        </div>
      ),
      hoverState: {
        title: (
          <div className={css.stepsSection1Card1Hover}>
            Get paid on time, every time.
          </div>
        ),
        body: 'With Guaranteed Rent, you get paid on the first, even if your residents are late on\u00a0rent.',
      },
    },
    {
      src: 'homeowner-lp/ho_lp_section_03.jpg',
      title: <div className={css.stepsSection1Card3}>Financial Alignment</div>,
      hoverState: {
        title: (
          <div className={css.stepsSection1Card3Hover}>
            We partner with you to maximize long-term gains.
          </div>
        ),
        body: 'We don’t make money if you aren’t first, starting with a full wealth analysis of your home to understand long-term gains and monthly cash\u00A0flow.',
      },
    },
    {
      src: 'homeowner-lp/ho_lp_section_05.png',
      title: (
        <div
          className={css.stepsSection1Card2}
        >{`24/7\u00a0Emergency Support`}</div>
      ),
      hoverState: {
        title: (
          <div className={css.stepsSection1Card2Hover}>
            No more phone tag. We are here for you.
          </div>
        ),
        body: 'To care for you and your home, your dedicated Concierge works with a team to offer 24/7\u00a0support.',
      },
    },
  ],
  section2: [
    {
      src: 'homeowner-lp/ho_lp_section_09.png',
      title: (
        <div className={css.stepsSection3Card1}>
          {'Get qualified & hand\u00a0us\u00a0the\u00a0keys.'}
        </div>
      ),
    },
    {
      src: 'homeowner-lp/ho_lp_section_11.png',
      title: (
        <div className={css.stepsSection3Card2}>
          We’ll find someone to{' '}
          <span className="text-dark-gray line-through">rent</span> love your
          home.
        </div>
      ),
    },
    {
      src: 'homeowner-lp/ho_lp_section_10.png',
      title: 'Get Smooth Payments™ and\u00a0never\u00a0worry\u00a0again.',
    },
  ],
};
